var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../../libs/gojs/release/go';
import { LineElement } from '../base/line-element';
import { DiagramConsts } from '../../diagram-consts';
var PolygonElement = /** @class */ (function (_super) {
    __extends(PolygonElement, _super);
    function PolygonElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolygonElement.prototype.compile = function (model, data, _svg) {
        model['version'] = 4;
        model['strokeWidth'] = data.strokeWidth;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
    };
    PolygonElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/polygon.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    PolygonElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Spot', {
            resizable: true, resizeObjectName: 'SHAPE',
            selectionAdorned: true, selectionObjectName: 'SHAPE',
            reshapable: true, locationObjectName: 'SHAPE',
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder, new go.Binding('padding', '', function (data) {
                return -data.strokeWidth / 2;
            }))))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('zOrder'), $(go.Shape, { name: 'SHAPE', stroke: 'black', fill: 'white', strokeWidth: 1,
            geometryString: 'F M 0,17.32 L 10,0 30,0 40,17.32 30,34.64 10,34.64 z', isPanelMain: true }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('stroke'), new go.Binding('fill'), new go.Binding('geometryString', 'geo').makeTwoWay(), new go.Binding('strokeWidth'), new go.Binding('strokeDashArray', '', function (data) {
            return _this.getStrokeDasharray(data.lineType);
        })));
    };
    PolygonElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.polygonKey;
    };
    return PolygonElement;
}(LineElement));
export { PolygonElement };
